<template>
  <div v-if="comType == 'UI'">
    <div
      :style="{
        position: 'relative',
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        overflow: 'hidden',
        'background-color': backgroundColor,
      }"
    >
      <div :class="{ original: !imgUrl }">
        <img v-if="imgUrl" :src="imgUrl" />
        <div
          class="hot"
          v-for="(item, index) in hotList"
          :key="index"
          :style="{
            position: 'absolute',
            left: `${item.left}px`,
            top: `${item.top}px`,
            width: `${item.width}px`,
            height: `${item.height}px`,
            'border-radius': `${item.radius}px`,
            'border-width': '1px',
          }"
        >
          {{ index }}
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="背景图">
          <customUpload :imageUrl.sync="imgUrlValue"></customUpload>
          <div class="tip">图片宽度限制:750px</div>
        </el-form-item>
      </div>
      <div v-show="imgUrlValue">
        <el-form-item label="跳转链接">
          <jumpConfig :jumpLink.sync="jumpLinkValue"></jumpConfig>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <div>
          <el-form-item label="圆角">
            <div class="slider-block">
              <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
              <div class="set-radius">
                <el-popover placement="top" width="160" trigger="hover">
                  <radiusBox :radius="radiusValue"></radiusBox>
                  <el-button slot="reference">可见性</el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上间距">
            <div class="slider-block">
              <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下间距">
            <div class="slider-block">
              <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左间距">
            <div class="slider-block">
              <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右间距">
            <div class="slider-block">
              <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="上内间距">
            <div class="slider-block">
              <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下内间距">
            <div class="slider-block">
              <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左内间距">
            <div class="slider-block">
              <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右内间距">
            <div class="slider-block">
              <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import customUpload from "@/components/appltDecoration/customUpload";
import jumpConfig from "@/components/appltDecoration/jumpConfig";
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";
export default {
  mixins: [comMixins],
  name: "comImage",
  components: {
    customUpload,
    jumpConfig,
    radiusBox,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    imgUrl: {
      type: String,
      default: "",
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    paddingTop: {
      type: Number,
      default: 0,
    },
    paddingRight: {
      type: Number,
      default: 0,
    },
    paddingBottom: {
      type: Number,
      default: 0,
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    radius: {
      type: Number,
      default: 0,
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    hotList: {
      type: Array,
      default: () => {
        return [
          {
            top: 0,
            left: 0,
            width: 100,
            height: 100,
            radius: 0,
          },
        ];
      },
    },
    jumpLink: {
      type: Object,
      default: () => {
        return {
          type: 1, // 1小程序页面，2跳转商品页，3商品分组
          remark: "",
        };
      },
    },
  },
  computed: {
    imgUrlValue: {
      get() {
        return this.imgUrl;
      },
      set(val) {
        this.$emit(`update:imgUrl`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    jumpLinkValue: {
      get() {
        return this.jumpLink;
      },
      set(val) {
        console.log("jumpLink", val);
        this.$emit(`update:jumpLink`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
.original {
  height: 130px;
  .default-img {
    width: 100%;
    height: 100%;
  }
  .hot {
    color: #fff;
    font-size: 16px;
    border-color: #409eff;
    background-color: rgba(64, 158, 255, 0.2);
  }
}
</style>
